import { Spin, Table, type TableProps } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'

import { SchoolService } from '@services/SchoolService'

import type { BillableAction } from '../../../../types'

type BillableActionTableProps = {
    schoolId: string
    subscriptionId: string
}

export const BillableActionsTable = ({ schoolId, subscriptionId }: BillableActionTableProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [billableActions, setBillableActions] = useState<BillableAction[]>()

    const fetchBillables = async () => {
        try {
            setIsLoading(true)
            const results = await SchoolService.getSubscriptionBillableActions(schoolId, subscriptionId)
            setBillableActions(results)
        } catch (err) {
            console.error('Could not fetch billables')
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchBillables()
    }, [])

    const columns: TableProps<BillableAction>['columns'] = [
        {
            title: 'units',
            dataIndex: 'units'
        },
        {
            title: 'Action',
            dataIndex: 'action'
        },
        {
            title: 'Cost Per Unit',
            dataIndex: 'costPerUnit'
        },
        {
            title: 'Currency',
            dataIndex: 'currency'
        },
        {
            title: 'Created At',
            key: 'createdAt',
            render: (_, { createdAt }) => <>{dayjs(createdAt).fromNow()}</>
        },
        {
            title: 'isBilled',
            key: 'isBilled',
            render: (_, { isBilled }) => <>{isBilled ? <>Yes</> : <>No</>}</>
        }
    ]

    if (isLoading) {
        return <Spin />
    }

    return <Table columns={columns} dataSource={billableActions || []} rowKey="id" pagination={{ pageSize: 10 }} />
}
